import { loginUrl } from '@/service/util';
import { getCookie } from 'lowcode/common/ABTestClient/ABTestCookie';
import getDefaultHeader from 'lowcode/utils/service/getDefaultHeader';
import { createToken } from '@/utils/request';

// 查询秒杀活动ID列表
export const getLists = async (locale: string) => {
    const headers: any = getDefaultHeader(locale);
    const token = getCookie('token');
    const res = await fetch(`${loginUrl(locale)}/integral/admin/seckillCampaign/listCampaign`, {
        method: 'GET',
        headers: {
            ...headers,
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        next: { revalidate: 5 },
    });

    return res.json();
};

// 根据秒杀活动ID查询秒杀活动详情 B端
export const getDetailB = async (locale: string, campaignId: string | number) => {
    const headers: any = getDefaultHeader(locale);
    const token = getCookie('token');
    const res = await fetch(`${loginUrl(locale)}/integral/admin/seckillCampaign/selectById2?campaignId=${campaignId}`, {
        method: 'GET',
        headers: {
            ...headers,
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        next: { revalidate: 5 },
    });

    return res.json();
};

// 根据秒杀活动ID查询秒杀活动详情 C端
export const getDetailC = async (locale: string, campaignId: string | number, token?: string, expectedNow?: string) => {
    const headers: any = getDefaultHeader(locale);
    const url =
        token && expectedNow
            ? `${loginUrl(locale)}/integral/web/seckillCampaign/getSeckillCampaign?campaignId=${campaignId}&token=${token}&expectedNow=${expectedNow}`
            : `${loginUrl(locale)}/integral/web/seckillCampaign/getSeckillCampaign?campaignId=${campaignId}`;
    const res = await fetch(url, {
        method: 'GET',
        headers: {
            ...headers,
            'Content-Type': 'application/json',
            Authorization: `Bearer ${createToken()}`,
        },
        next: { revalidate: 5 },
    });

    return res.json();
};

// 根据秒杀活动ID查询产品链接 C端
export const getProductC = async (data: any, locale: string) => {
    const headers: any = getDefaultHeader(locale);
    const res = await fetch(`${loginUrl(locale)}/integral/web/seckillCampaign/getSecKillProductUrl`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            ...headers,
            'Content-Type': 'application/json',
            Authorization: `Bearer ${createToken()}`,
        },
        next: { revalidate: 5 },
    });

    return res.json();
};
